import { resolveStoredFileUrl } from "utils/storedFileUrl";
// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  Input,
  InputLabel,
  Modal,
  Tooltip,
} from "@mui/material";

import { gql, useMutation } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { allFoodIcons } from "utils/foodIcons";
// import { ConfirmarContext } from "context/ConfirmarContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflowY: "auto",
  p: 3,
};
const allowedFileTypes = ".jpg,.jpeg,.png,.gif,.bmp";

const categoriaInicial = {
  nombre: "",
  icono: "",
  file: null,
};
export default function ModalCategoria({ open, handleClose, refetch, selectedCategoria }) {
  const [categoria, setCategoria] = useState(categoriaInicial);
  const [file, setFile] = useState(null);
  const [keyFile, setKeyFile] = useState(0);

  const handleChangeCategoria = (e) => {
    setCategoria({
      ...categoria,
      [e.target.name]: e.target.value,
    });
  };
  const { handleSnackbar } = useContext(MessageManager);
  // const { confirmar } = useContext(ConfirmarContext);

  const [saveCategoria, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveCategoria($input: CategoriaProductoInput!) {
        saveCategoria(input: $input) {
          id
        }
      }
    `
  );

  const handleSave = () => {
    let inputSave =
      !file && categoria.file
        ? {
            id: selectedCategoria ? selectedCategoria.id : null,
            categoria: categoria.categoria,
            icono: categoria.icono,
          }
        : {
            id: selectedCategoria ? selectedCategoria.id : null,
            categoria: categoria.categoria,
            icono: categoria.icono,
            file: file,
          };
    saveCategoria({
      variables: {
        input: {
          ...inputSave,
        },
      },
    })
      .then(() => {
        handleSnackbar("Categoria guardada correctamente", "success");
        refetch();
        handleRemoveFile();
        handleClose();
      })
      .catch(() => {
        handleSnackbar("Error al guardar el categoria", "error");
      });
  };

  useEffect(() => {
    if (selectedCategoria) {
      setCategoria(selectedCategoria);
    } else {
      setCategoria(categoriaInicial);
    }
  }, [selectedCategoria, open]);

  //Lógica archivos imágen
  const toggleInput = () => {
    document.getElementById("input-file").click();
  };
  const handleRemoveFile = () => {
    setKeyFile((prev) => prev + 1);
    setFile(null);
    setCategoria({ ...categoria, file: null });
  };
  const handleFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Categoria</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox py={2}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <InputLabel htmlFor="nombre">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Nombre
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    placeholder="Ingrese el nombre"
                    type="text"
                    name="categoria"
                    value={categoria.categoria}
                    onChange={handleChangeCategoria}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="nombre">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Ícono
                    </SoftTypography>
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <SoftBox p={2}>
                      <Grid container spacing={2}>
                        {allFoodIcons.map((icono, index) => (
                          <Grid
                            item
                            key={index}
                            xs={3}
                            sm={3}
                            md={3}
                            lg={2}
                            display="flex"
                            justifyContent="center"
                          >
                            <Icon
                              sx={{
                                cursor: "pointer",
                              }}
                              fontSize="lg"
                              color={categoria.icono === icono ? "primary" : "inherit"}
                              onClick={() => {
                                setCategoria({
                                  ...categoria,
                                  icono: icono,
                                });
                              }}
                            >
                              {icono}
                            </Icon>
                          </Grid>
                        ))}
                      </Grid>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={12} container>
                  <InputLabel htmlFor="imagen">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Imágen
                    </SoftTypography>
                    {(file || categoria.file) && (
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={handleRemoveFile}
                      >
                        &nbsp; - Quitar imágen <Icon>cancel</Icon>
                      </SoftTypography>
                    )}
                  </InputLabel>
                  {file || categoria.file ? (
                    <Grid itm xs={12} display="flex" justifyContent="center">
                      <Grid display="flex" justifyContent="center" alignItems="center">
                        <img
                          src={file ? URL.createObjectURL(file) : resolveStoredFileUrl(categoria.file)}
                          alt="imagen"
                          style={{ objectFit: "cover", width: "100%" }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      display="flex"
                      justifyContent="center"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <SoftButton color="dark" circular onClick={toggleInput}>
                        <Icon>add_a_photo</Icon>
                        &nbsp;Agregar
                      </SoftButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="flex-end"
              alignItems="center"
            >
              <SoftBox
                display={{
                  xs: "flex-row",
                  sm: "flex",
                }}
                justifyContent="end"
                alignItems="center"
              >
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="primary"
                    circular
                    onClick={() => {
                      handleClose();
                      handleRemoveFile();
                    }}
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    disabled={loadingSave}
                  >
                    <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                    &nbsp;Cancelar
                  </SoftButton>
                </SoftBox>
                <SoftBox
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="uproGreen"
                    circular
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    onClick={handleSave}
                    disabled={loadingSave || !categoria.categoria}
                  >
                    {false ? (
                      <CircularProgress size={15} color="inherit" />
                    ) : (
                      <Icon sx={{ fontWeight: "light" }}>save</Icon>
                    )}
                    &nbsp;Guardar
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <Grid sx={{ display: "none" }}>
              <Input
                type="file"
                id="input-file"
                onChange={handleFile}
                name="recibos"
                inputProps={{ accept: allowedFileTypes, multiple: false }}
                key={keyFile}
              />
            </Grid>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalCategoria.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  selectedCategoria: PropTypes.object,
};
